import { useMemo } from 'react';
import { MarketIndicatorTransformationType } from '../../../../../../../Generated/Raven-Demeter';
import Dropdown from '../../../../../../Components/Form/Inputs/Dropdown';
import LabelWithTooltip from '../../../../../../Components/Form/Inputs/LabelWithTooltip';
import useLanguage from '../../../../../../Services/Language/useLanguageHook';
import { TrackingEvent } from '../../../../../../Services/Tracking/TrackingService';
import styles from '../../MarketIndicatorFactorPage.module.scss';

interface IDataSelectorDataTransformationDropdownProps {
    disabled?: boolean;
    transformationType?: MarketIndicatorTransformationType;
    handleChange: (transformationType?: MarketIndicatorTransformationType) => void;
    notAllowedTransformationTypes?: MarketIndicatorTransformationType[];
    track: TrackingEvent;
}

const DataSelectorDataTransformationDropdown: React.FC<IDataSelectorDataTransformationDropdownProps> = (
    props: IDataSelectorDataTransformationDropdownProps,
) => {
    // Application hooks.
    const [translations] = useLanguage();
    const dataTransformationOptions = useMemo(
        () =>
            [
                {
                    label: translations.words.none,
                    value: undefined,
                },
                {
                    label: translations.marketIndicatorTransformationType[MarketIndicatorTransformationType.YearOverYearChange],
                    value: MarketIndicatorTransformationType.YearOverYearChange,
                },
                {
                    label: translations.marketIndicatorTransformationType[MarketIndicatorTransformationType.MonthOverMonthChange],
                    value: MarketIndicatorTransformationType.MonthOverMonthChange,
                },
                {
                    label: translations.marketIndicatorTransformationType[MarketIndicatorTransformationType.WeekOverWeekChange],
                    value: MarketIndicatorTransformationType.WeekOverWeekChange,
                },
                {
                    label: translations.marketIndicatorTransformationType[MarketIndicatorTransformationType.DayOverDayChange],
                    value: MarketIndicatorTransformationType.DayOverDayChange,
                },
                {
                    label: translations.marketIndicatorTransformationType[MarketIndicatorTransformationType.Multiply],
                    value: MarketIndicatorTransformationType.Multiply,
                },
                {
                    label: translations.marketIndicatorTransformationType[MarketIndicatorTransformationType.RelativeStrengthIndex],
                    value: MarketIndicatorTransformationType.RelativeStrengthIndex,
                },
                {
                    label: translations.marketIndicatorTransformationType[MarketIndicatorTransformationType.RollingAverage],
                    value: MarketIndicatorTransformationType.RollingAverage,
                },
                {
                    label: translations.marketIndicatorTransformationType[MarketIndicatorTransformationType.RollingAverageForwardContracts],
                    value: MarketIndicatorTransformationType.RollingAverageForwardContracts,
                },
                {
                    label: translations.marketIndicatorTransformationType[MarketIndicatorTransformationType.Trend],
                    value: MarketIndicatorTransformationType.Trend,
                },
            ] as { label: string; value: MarketIndicatorTransformationType }[],
        [translations],
    );

    return (
        <div className={styles.indicator_add_and_edit_dropdown}>
            <Dropdown
                disabled={props.disabled}
                value={dataTransformationOptions.find((x) => x.value === props.transformationType)?.value}
                options={dataTransformationOptions.filter(
                    (x) =>
                        !props.notAllowedTransformationTypes || (props.notAllowedTransformationTypes && !props.notAllowedTransformationTypes.includes(x.value)),
                )}
                handleOptionChange={(value) => props.handleChange(value)}
                label={
                    <LabelWithTooltip
                        title={translations.marketIndicatorsManagement.fields.dataTransformation}
                        tooltip={translations.marketIndicatorsManagement.text.dataTransformationTooltip}
                    />
                }
                track={props.track}
            />
        </div>
    );
};

export default DataSelectorDataTransformationDropdown;
